import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FullCalendarReact from "../../../components-react/FullCalendarReact";
import { fetchApiData } from "../../../../redux/reducers/commonApiSlice";
import {
  convertTo12HourFormat,
  currentMonthEndDate,
  currentMonthStartDate,
} from "../../../common-data/Converts";
import { cal_view_staff_attendance } from "../../../../data/ApiEndpoints";
import StatCardDetails from "./StatCardDetails";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";

const StaffCalendarViewReport = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.common);

  const iniAllFilters = {
    selStartDate: currentMonthStartDate,
    selEndDate: currentMonthEndDate,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    user_id: rowData?.user_id || "",
    date_from: allFilters.selStartDate || "",
    date_to: allFilters.selEndDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [calAttendanceData, setCalAttendanceData] = useState([]);
  const [calStats, setCalStats] = useState({});

  function getCalViewAttendace(filters = {}) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: cal_view_staff_attendance,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      date_from: allFilters.selStartDate,
      date_to: allFilters.selEndDate,
    }));
  }, [allFilters]);

  useEffect(() => {
    if (filters.user_id) {
      getCalViewAttendace(filters);
    }
  }, [filters]);

  useEffect(() => {
    if (data?.status && data?.data && !loading) {
      setCalAttendanceData(data?.data);
      setCalStats(data?.stats ? data.stats : {});
    } else {
      setCalAttendanceData([]);
      setCalStats({});
    }
  }, [data, loading]);

  const renderEventContent = useCallback(
    (eventInfo) => {
      const { shift_details, checkin_status } = eventInfo.event?.extendedProps;

      const isAbsent =
        checkin_status === "day_off" ||
        checkin_status === "on_leave" ||
        checkin_status === "not_checked_in";

      console.log(isAbsent, " <=checkin_status=> ", checkin_status);

      return (
        <div className="cal-view-grid-container staff-attendance-cal-view-container">
          {isAbsent ? (
            <div className="square-box">
              <p className="day-off-info">
                {checkin_status?.replace(/_/g, " ") || "-"}
              </p>
            </div>
          ) : (
            <>
              {shift_details?.map((shift, index) => {
                const {
                  shift_start,
                  end_time,
                  shift_name,
                  attendance_details,
                } = shift || {};
                const {
                  checkin_time,
                  checkout_time,
                  shift_difference,
                  status,
                  shift_status,
                } = attendance_details || {};

                const checkinTime = checkin_time
                  ? convertTo12HourFormat(checkin_time)
                  : "";
                const checkoutTime = checkout_time
                  ? convertTo12HourFormat(checkout_time)
                  : "";
                const checkinReport = status ? status?.toLowerCase() : "";
                const checkinReportTime = shift_difference
                  ? shift_difference
                  : "";

                return (
                  <div className="cal-attendance-data" key={index}>
                    <div className="shift-box">
                      <span className="shift-name">
                        shift {index + 1} ({shift_name || ""})
                      </span>
                    </div>

                    <div className="checkin-checkout-box">
                      <div className="checkin-box checkin">
                        <span className="label">Checkin</span>
                        <span className="time">{checkinTime || "-"}</span>
                        <span
                          className="status"
                          style={{
                            color:
                              checkinReport === "late" ? "#CC0A39" : "#3B66D6",
                          }}
                        >
                          {status || ""}{" "}
                          {status !== "On Time" && checkinReportTime
                            ? checkinReportTime
                            : ""}
                        </span>
                      </div>

                      <div className="gray-line-long"></div>

                      <div className="checkin-box checkout">
                        <span className="label">Checkout</span>
                        <span className="time">{checkoutTime || "-"}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      );
    },
    [calAttendanceData]
  );

  return (
    <div className="calender-view-checkins-container">
      <div className="calendar-stats-container">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <StatCardDetails calStats={calStats} />
        )}
      </div>
      <div className="calender-view-checkins big-calendar-container">
        <FullCalendarReact
          events={calAttendanceData}
          setCurrentMonth={setAllFilters}
          renderEventContent={renderEventContent}
        />
      </div>
    </div>
  );
};

export default StaffCalendarViewReport;
